<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <employee-coached-details>
        </employee-coached-details> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import employeeCoachedDetails from './todo-employee-coached-details'
export default {
    components: {
        employeeCoachedDetails
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-employee-coached-details.vue